import { arrayOf, bool, number, shape, string } from 'prop-types'

import { StockStatusType } from './api'
import { OfferType } from './offerType'

export const productLabelType = string

export const productType = {
  amount: string.isRequired,
  brand: string.isRequired,
  darreichung: string.isRequired,
  descriptionShort: string.isRequired,
  discountPercent: number.isRequired,
  famId: string.isRequired,
  free: bool.isRequired,
  imageUrl: string.isRequired,
  imageUrlLarge: string.isRequired,
  labels: arrayOf(string).isRequired,
  manufacturer: string.isRequired,
  name: string.isRequired,
  pzn: string.isRequired,
  rating: number.isRequired,
  ratingCount: number.isRequired,
  stockStatus: shape(StockStatusType).isRequired,
  type: string.isRequired,
  // TODO Add a “.isRequired” once we migrate fully to marketplace
  offer: OfferType,
}

export const productShapeType = shape(productType)
